import get from 'lodash/get';
import {v4} from 'uuid';

import store, {AppDispatchType, StoreType} from 'app/store/AppStore';

import {updateTaskStatus} from 'app/subscriptions/slice';

export const taskDispatcher =
  (taskPromise: Promise<unknown>) =>
  (dispatch: AppDispatchType, getState: StoreType['getState']): Promise<any> =>
    new Promise((resolve, reject) => {
      let taskKey: string;

      const unsubscribe = store.subscribe(() => {
        /* bail out if we don't know the task key */
        if (taskKey == null) {
          return;
        }

        const task = getState().subscriptions.tasksStatus[taskKey];

        if (task != null && task.status !== 'processing') {
          unsubscribe();

          return task.status === 'complete' || task.status === 'completed'
            ? resolve(task)
            : reject(task.message);
        }
      });

      const handleCreationResponse = (forceStatus?: 'error' | 'processing') => {
        return (
          response: {task_key: string; status: 'processing'} | {status: 'error'}
        ) => {
          // if the task creation failed we generate a fake task key to show error
          taskKey = get(response, 'task_key', `fake-taskkey-${v4()}`);

          /* if the task already has a status just ignore the status in the POST response #5641 */
          if (getState().subscriptions.tasksStatus[taskKey] != null) {
            return;
          }

          dispatch(
            updateTaskStatus({
              ...response,
              task_key: taskKey,
              status: forceStatus ?? response.status,
            })
          );
          return response;
        };
      };

      taskPromise.then(
        handleCreationResponse(),
        handleCreationResponse('error')
      );
    });
